import styled from 'styled-components';

import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';
import { StyledButtonAddPage } from '../ButtonAddPage/styles';
import { editorScrollStyles } from '../../Editor/styles';

interface StyledThumbnailsProps {
	isDisplayed: boolean;
}

interface StyledThumbnailsItemProps {
	isActive: boolean;
	isBlurred: boolean;
}

interface StyledThumbnailsIconProps {
	isActive: boolean;
	width?: number;
	noBackground?: boolean;
}

interface ThumbnailsListProps {
	isMobileApp: boolean;
}

const StyledThumbnails = styled('div')`
	box-sizing: border-box;
	display: ${(props: StyledThumbnailsProps) => props.isDisplayed ? 'flex' : 'none'};
	flex-direction: column;
	flex: 0 0 152px;
	min-width: 0;
	border-right: 2px solid ${hexToRgba(StyleColor.White, 10)};

	${StyledButtonAddPage} {
		flex: 0 0 auto;
		margin: 16px auto;
	}
`;

const ThumbnailsList = styled('ul')`
	flex: 1 1 auto;
	width: 150px;
	margin: 0;
	padding: 0;
	list-style-type: none;
	overflow-x: hidden;
	overflow-y: auto;

	${(props: ThumbnailsListProps) => !props.isMobileApp && editorScrollStyles}
`;

const StyledThumbnailsItem = styled('li')`
	background-color: ${({ isActive }: StyledThumbnailsItemProps) => isActive ? `${StyleColor.Blue600}` : `${NewStyleColor.Grey900}`};
	cursor: default !important;
	user-select: none;

	${({ isBlurred }: StyledThumbnailsItemProps) => isBlurred && 'opacity: 0.05;'}
`;

const ThumbnailsInner = styled('div')`
	box-sizing: border-box;
	position: relative;
	padding: 6px 10px 7px 32px;
	border-bottom: 1px solid ${NewStyleColor.Grey900};
	background-color: inherit;
	font-family: HelveticaNeue, sans-serif;
	color: ${StyleColor.White};

	&:focus {
		outline: 0;
	}
`;

const ThumbnailsItemPosition = styled('span')`
	position: absolute;
	top: 61px;
	left: 5px;
	width: 20px;
	font-size: 9px;
	line-height: 11px;
	text-align: right;
`;

const ThumbnailsImageWrapper = styled('div')`
	position: relative;
	width: 91px;
	height: 66px;
	margin-bottom: 5px;
	background-color: ${StyleColor.Black};

	img {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		max-width: 100%;
		max-height: 100%;
		width: auto;
		height: auto;
		margin: auto;
	}
`;

const ThumbnailsInfo = styled('div')`
	display: flex;
	align-items: center;
`;

const ThumbnailsItemLabel = styled('div')`
	box-sizing: border-box;
	position: relative;
	/* The max-height and display block are for IE not recognizing display box and line-clamp */
	display: block;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	width: 79px;
	max-height: 18px;
	padding-right: 10px;
	font-weight: 500;
	font-size: 8px;
	line-height: 9px;
	opacity: 0.65;
	text-align: justify;
	overflow: hidden;
	word-break: break-all;
`;

const StyledThumbnailsIcon = styled('div')`
	flex: 0 0 16px;
	height: 16px;
	margin-right: 6px;
	border-radius: 4px;
	background-color: ${(props: StyledThumbnailsIconProps) => props.noBackground ? '' : `${StyleColor.White}`};

	svg {
		width: ${(props: StyledThumbnailsIconProps) => props.width ? `${props.width}px` : '16px'};
		height: 16px;
		fill: ${(props: StyledThumbnailsIconProps) => props.isActive ? `${StyleColor.Black}` : ''};
	}
`;

const ThumbnailsEditIcon = styled('div')`
	position: absolute;
	top: 14px;
	left: 86px;
	width: 37px;
	height: 31px;
	border-radius: 15px 0 0 15px;
	background-color: ${StyleColor.White};
	box-shadow: -1px 2px 7px 0 ${hexToRgba(StyleColor.Black, 48)}, 0 0 1px 0 ${hexToRgba(StyleColor.Black, 87)};

	svg {
		position: absolute;
		top: 6px;
		left: 10px;
		width: 18px;
		height: 19px;
		fill: ${hexToRgba(StyleColor.Black, 70)};
	}
`;

const ThumbnailsSelectedNumber = styled('div')`
	position: absolute;
	top: -5px;
	right: -5px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	border: 2px solid currentColor;
	border-radius: 50%;
	background-color: ${StyleColor.White};
	font-weight: 700;
	font-size: 10px;
	color: ${StyleColor.Blue600};
`;

export {
	StyledThumbnails,
	ThumbnailsList,
	StyledThumbnailsItem,
	ThumbnailsInner,
	ThumbnailsItemPosition,
	ThumbnailsImageWrapper,
	ThumbnailsInfo,
	ThumbnailsItemLabel,
	StyledThumbnailsIcon,
	ThumbnailsEditIcon,
	ThumbnailsSelectedNumber,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Thumbnails/styles.ts